export default () => ({
  scrolled: false,
  opened: false,

  init() {
    this.scrolled = pageYOffset > 0;
    window.addEventListener('scroll', () => this.scrolled = pageYOffset > 0);
  }
})